import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.tsx';

// Global fetch interceptor - Tüm API çağrılarında 401 kontrolü yap
const originalFetch = window.fetch;
window.fetch = async (...args: Parameters<typeof fetch>): Promise<Response> => {
  const response = await originalFetch(...args);
  
  // 401 hatası geldiyse token expired event'i dispatch et
  if (response.status === 401) {
    // Sadece admin panel API çağrılarında kontrol et (login sayfası hariç)
    const url = typeof args[0] === 'string' ? args[0] : args[0].url;
    if (url && !url.includes('/api/auth/staff/login')) {
      window.dispatchEvent(new CustomEvent('tokenExpired'));
    }
  }
  
  return response;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
